import { createSelector } from 'reselect';
import { TravellerFieldEnum } from '@websky/graphql';
import { API_DATE_FORMAT, format, getTravellerName, getUserValue } from '../../../../utils';
import { getOrderId, getOrderHash, getCustomer, getTravellers, getLastExchange } from '../../../../Checkout/store/order/selectors';
import { getSelectedPassengers, getSelectedPassengersIds, getSelectedPassengersParams } from './passengers/selectors';
import { getSelectedSegments, getSelectedSegmentsIds, getSelectedSegmentsParams, getIsAllSegmentsSelected } from './segments/selectors';
import { getSelectedFlightsCount, getFirstSelectedFlight, getFirstSelectedFlightActualPriceId } from './exchangeVariants/selectors';
export const getExchangeState = (state) => state.exchange;
export const getSearchParameters = createSelector(getSelectedPassengersParams, getSelectedSegmentsParams, (passengersParams, segmentsParams) => {
    return {
        passengers: passengersParams,
        segments: segmentsParams
    };
});
export const getExchangeVariantsParams = createSelector(getOrderId, getSelectedPassengersIds, getSelectedSegments, (orderId, selectedPassengersIds, selectedSegments) => ({
    orderId,
    passengers: selectedPassengersIds.map(Number),
    segmentParams: selectedSegments.map(segment => {
        var _a;
        return ({
            segmentGroupId: segment.id,
            date: format((_a = segment.selectedDate) !== null && _a !== void 0 ? _a : segment.date, API_DATE_FORMAT)
        });
    }),
    isCompelled: false
}));
export const getSelectedSegmentOnLeg = createSelector(getSelectedSegments, getSelectedFlightsCount, (selectedSegments, selectedFlightsCount) => selectedSegments[selectedFlightsCount]);
export const getSelectedSegmentMinDate = createSelector(getSelectedSegments, getSelectedFlightsCount, (selectedSegments, selectedFlightsCount) => {
    var _a;
    const prevSelectedSegment = selectedSegments[selectedFlightsCount - 1];
    if (!prevSelectedSegment) {
        return new Date(new Date().setHours(0, 0, 0, 0));
    }
    return (_a = prevSelectedSegment.selectedDate) !== null && _a !== void 0 ? _a : prevSelectedSegment.date;
});
export const getRefundServicesParams = createSelector(getOrderId, getLastExchange, getTravellers, getSelectedPassengersIds, getSelectedSegmentsIds, getIsAllSegmentsSelected, (orderId, lastExchange, passengers, selectedPassengerIds, selectedSegmentIds, allFlightToExchange) => {
    if (lastExchange) {
        return {
            orderId,
            passengers: [],
            selectedSegmentIds: [],
            selectedPassengerIds: [],
            allFlightToExchange: false
        };
    }
    return {
        orderId,
        passengers,
        selectedPassengerIds,
        selectedSegmentIds,
        allFlightToExchange
    };
});
export const getInitialFormValues = createSelector(getCustomer, getSelectedPassengers, (customer, selectedPassengersValues) => {
    var _a, _b;
    const { fullName, email, phone } = (_b = (_a = selectedPassengersValues[0]) === null || _a === void 0 ? void 0 : _a.values) !== null && _b !== void 0 ? _b : {};
    return {
        name: fullName || getTravellerName(customer),
        email: email || getUserValue(customer, TravellerFieldEnum.Email),
        phone: phone || getUserValue(customer, TravellerFieldEnum.Phone),
        comment: ''
    };
});
export const getCreateExchangeParams = createSelector(getOrderId, getSelectedPassengersIds, getSelectedSegmentsIds, getFirstSelectedFlightActualPriceId, (orderId, selectedPassengersIds, selectedSegmentsIds, firstSelectedFlightActualPriceId) => ({
    orderId,
    passengers: selectedPassengersIds.map(Number),
    segmentGroupId: Number(selectedSegmentsIds[0]),
    newFlightId: firstSelectedFlightActualPriceId,
    isCompelled: false,
    comment: ''
}));
export const getExchangePriceParameters = createSelector(getOrderId, getOrderHash, getFirstSelectedFlight, getSelectedPassengersIds, (orderId, orderStateHash, firstSelectedFlight, selectedPassengersIds) => {
    return {
        orderId,
        orderStateHash,
        flightId: firstSelectedFlight.priceId,
        passengers: selectedPassengersIds.map(Number)
    };
});
